import { TimePicker, TimePickerProps } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import { Control, FieldValues, Path, useController, UseFormTrigger } from 'react-hook-form';

export interface TimePickerRhfProps<T extends FieldValues> extends TimePickerProps<DateTime> {
    control: Control<T>; // Controller attribute from the form
    name: Path<T>; // Field name from the form
    trigger?: UseFormTrigger<T>; // Form trigger valid
}

export const TimePickerRhf = <T extends FieldValues>({
    control,
    name,
    trigger,
    ...timePickerProps
}: TimePickerRhfProps<T>) => {
    const {
        field: { onChange, value },
        fieldState: { error },
    } = useController({
        name,
        control,
    });

    return (
        <TimePicker
            value={DateTime.fromISO(value as string)}
            onChange={(newDate) => {
                onChange(newDate?.toFormat('HH:mm') ?? null);
                trigger?.(name); // Trigger validation to update the "error" value
            }}
            slotProps={{ textField: { error: !!error } }}
            views={['hours', 'minutes']}
            ampm={false}
            minutesStep={10}
            timeSteps={{ minutes: 10 }}
            sx={{
                '&>.MuiInputBase-root': { height: '48px' },
                'flex': 1,
            }}
            {...timePickerProps}
        />
    );
};
